class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances =
      document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
   

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    // this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    const _this = this;
    document.addEventListener('click', function(e){
      let el = e.target;
      if(el.classList.contains('predictive-search__result-tabs-nav-item')) {
        e.preventDefault();
        const resultTabsEl = el.closest('.predictive-search__result-tabs');
        if(resultTabsEl) {
          const prevActiveNavEl = resultTabsEl.querySelector('.predictive-search__result-tabs-nav-item.active');
          const prevActiveTabEl = resultTabsEl.querySelector('.predictive-search__result-tabs-block.active');
          if(prevActiveNavEl) {
            prevActiveNavEl.classList.remove('active');
          }
          if(prevActiveTabEl) {
            prevActiveTabEl.classList.remove('active');
          }

          el.classList.add('active');
          const tabId = el.getAttribute('data-query');
          const activeTabEl = resultTabsEl.querySelector(`#${tabId}`);
          if(activeTabEl) {
            activeTabEl.classList.add('active');
          }
        }
      }
    });
    document.addEventListener('click', function(e){
  	let el = e.target;
    
    if(el.classList.contains('toggle_search_form__btn') || el.closest('.toggle_search_form__btn') || el.classList.contains('predictive-search-form-close-btn') || el.closest('.predictive-search-form-close-btn') ) {
      e.preventDefault();
      const searchParentEl = el.closest('.header-predictive-search-wrapper');
      if(searchParentEl) {
        searchParentEl.classList.toggle('active_form');

        if(!searchParentEl.classList.contains('active_form')) {
           _this.closeResults(true);
        }
      }
    }
  });
    document.addEventListener('click', (event) => {
      const searchParentEl = document.querySelector('.header-predictive-search-wrapper.active_form');  
      if(searchParentEl) {
        let el = event.target;
         if(el.classList.contains('toggle_search_form__btn') || el.closest('.toggle_search_form__btn')) {
           return false;
         } else {
          if (!_this.contains(event.target)) {
           searchParentEl.classList.remove('active_form');
            _this.closeResults(true);
          }
         }
      }
});
  }

  getQuery() {    
    return this.input.value.trim();  
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (!this.searchTerm.length) {
      this.close(true);
      
      return;
    }

    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]"
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(
      this.querySelectorAll("li, button.predictive-search__item")
    ).filter((element) => element.offsetParent !== null);
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = "";

    if (!moveUp && selectedElement) {
      activeElementIndex =
        selectedElementIndex === allVisibleElements.length - 1
          ? 0
          : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex =
        selectedElementIndex === 0
          ? allVisibleElements.length - 1
          : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector(
      '[aria-selected="true"] a, button[aria-selected="true"]'
    );

    if (selectedOption) selectedOption.click();
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

let baseUrl = `${routes.predictive_search_url}`;
let sectionId = 'predictive-search';

let productUrl = `${baseUrl}?q=${searchTerm}&resources[type]=product&resources[limit]=6&section_id=${sectionId}`;
let pageUrl = `${baseUrl}?q=${searchTerm}&resources[type]=page&resources[limit]=10&section_id=${sectionId}`;
let articleUrl = `${baseUrl}?q=${searchTerm}&resources[type]=article&resources[limit]=4&section_id=${sectionId}`;

Promise.all([
  fetch(productUrl, { signal: this.abortController.signal }).then((res) => res.text()),
  fetch(pageUrl, { signal: this.abortController.signal }).then((res) => res.text()),
  fetch(articleUrl, { signal: this.abortController.signal }).then((res) => res.text())
])
  .then(([productHTML, pageHTML, articleHTML]) => {
    // Парсинг HTML-контенту для кожного типу

    const productContent = new DOMParser().parseFromString(productHTML, 'text/html').querySelector('.predictive-search__result-tabs-block#predictive-search__result-product')?.innerHTML || '';
    const pageContent = new DOMParser().parseFromString(pageHTML, 'text/html').querySelector('.predictive-search__result-tabs-block#predictive-search__result-page')?.innerHTML || '';
    const articleContent = new DOMParser().parseFromString(articleHTML, 'text/html').querySelector('.predictive-search__result-tabs-block#predictive-search__result-article')?.innerHTML || '';

    // Обчислення загальної кількості результатів
    const productCount = productContent ? (productContent.match(/<li/g) || []).length : 0;
    const pageCount = pageContent ? (pageContent.match(/<li/g) || []).length : 0;
    const articleCount = articleContent ? (articleContent.match(/<li/g) || []).length : 0;
    const totalResults = productCount + pageCount + articleCount;


   let hideTabsClass = '';
    if(totalResults == 0) {
      hideTabsClass = 'hide';
    }
    // Об'єднання вкладених блоків у єдину структуру
    const combinedMarkup = `
      <div id="predictive-search-results" role="listbox">
        <div class="predictive-search__result-tabs ${hideTabsClass}">
          <div class="predictive-search__result-tabs-nav">
            ${productContent ? `<button type="button" class="predictive-search__result-tabs-nav-item active" data-query="predictive-search__result-product">Products</button>` : ''}
            ${articleContent ? `<button type="button" class="predictive-search__result-tabs-nav-item ${!productContent ? 'active' : ''}" data-query="predictive-search__result-article">Articles</button>` : ''}
            ${pageContent ? `<button type="button" class="predictive-search__result-tabs-nav-item ${!productContent && !articleContent ? 'active' : ''}" data-query="predictive-search__result-page">Pages</button>` : ''}
          </div>
          <div class="predictive-search__result-tabs-blocks">
            ${productContent ? `<div class="predictive-search__result-tabs-block active" id="predictive-search__result-product">${productContent}</div>` : ''}
            ${articleContent ? `<div class="predictive-search__result-tabs-block ${!productContent ? 'active' : ''}" id="predictive-search__result-article">${articleContent}</div>` : ''}
            ${pageContent ? `<div class="predictive-search__result-tabs-block ${!productContent && !articleContent ? 'active' : ''}" id="predictive-search__result-page">${pageContent}</div>` : ''}
          </div>
        </div>
       
          ${totalResults > 0 ? `<span class="hidden" data-predictive-search-live-region-count-value>Found ${totalResults} results across products, pages, and articles.</span>` :  `<span class="" data-predictive-search-live-region-count-value>No results found for your query.</span>`}
      
      </div>
    `;

    // Синхронізація кешу
    this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
      predictiveSearchInstance.cachedResults[queryKey] = combinedMarkup;
    });

    // Вставка результатів у DOM
    this.renderSearchResults(combinedMarkup);
  })
  .catch((error) => {
    if (error?.code === 20) {
      // Code 20 means the call was aborted
      return;
    }
    this.close();
    throw error;
  });



  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.setAttribute('results', true);
    this.predictiveSearchResults.innerHTML = resultsMarkup;
   

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector('.section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
